// @ts-strict-ignore
import styled from "styled-components";

export const ContentBox = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  border-radius: 16px;
  flex-direction: column;
  margin: 32px 0px 16px;
  & * {
    box-sizing: border-box;
  }
`;
